module.exports = __webpack_public_path__ + "assets/img/btn2-page.068cf4aa.png";